import React from 'react';
import ReactDOM from 'react-dom/client';


import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router,HashRouter } from 'react-router-dom';
import { AuthProvider } from './Context/AuthProvider';
import PersistLogin from './components/PersistLogin/PersistLogin';

{/* <AuthProvider>
            <App />
        </AuthProvider> */}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
  <React.StrictMode>
  <AuthProvider>
    <App />
    </AuthProvider>
  </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
